import { compose } from 'redux';
import actionTypes from './actionTypes';
import { serializeEditorial } from '../serializers';

const initialState = {
    isLoading: false,
    error: undefined,
    data: {} 
};

export default (state = initialState, action) => {
    switch(action.type){
    case actionTypes.LOAD_EDITORIAL_START:
        return {
            ...state,
            isLoading: true,
        };
    case actionTypes.LOAD_EDITORIAL_SUCCESS:
        return {
            ...state,
            isLoading: false, 
            data: serializeEditorial(action.payload.data[0])
        };
    case actionTypes.LOAD_EDITORIAL_FAIL:
        return {
            ...state,
            isLoading: false, 
            error: action.payload.error,
        };
    default: 
        return state;
    }
};